import React, { useState } from 'react';
import { GetLabelColor } from '../../lib/helpers';
import { Container, Table, Card, Button, Page, Dimmer, Avatar } from "tabler-react";
import Chat from '../../components/chat';
import { useLocation } from 'react-router-dom';
import PhotoModal from '../../components/modal/photoModal';
import SearchInput from '../../components/searchInput';

const RecordsTable = ({ headers, records, openMainModal, loading, status, reload, children, searchQuery, onSearch }) => {
  const [chatUser, setChatUser] = useState(null)
  const [modalPhoto, setModalPhoto] = useState(null)
  const { pathname } = useLocation()

  return (
    <Container>
      {modalPhoto &&
        <PhotoModal photo={modalPhoto} close={() => setModalPhoto(null)} />
      }

      <Page.Header>
        <Page.Title>Shipments</Page.Title>
      </Page.Header>
      <Card>
        <Dimmer active={loading} loader={loading}>
          <Card.Header>
            <Card.Options>
              <SearchInput value={searchQuery} onSubmit={onSearch} />
              <Button
                className="ml-2"
                icon="plus"
                color="primary"
                size="md"
                onClick={() => openMainModal('shipment-create', null, reload)}
              >
                Create Shipment
              </Button>
            </Card.Options>
          </Card.Header>

          {children}

          {!loading && records.length < 1 ? (
            <div className="alert alert-primary m-0">
              No Shipments to show!
            </div>
          ) : (
            <div className="table-responsive-wrapper">
              <Table hasOutline striped>
                <Table.Header>
                  {headers.map((head, i) => (
                    <Table.ColHeader key={`tableHeader-${i}`}>{head}</Table.ColHeader>
                  ))}
                  <Table.ColHeader>Actions</Table.ColHeader>
                </Table.Header>
                <Table.Body>
                  {records.map((r, i) => (
                    <Table.Row key={i}>
                      {Object.keys(r).map((k, idx) => {
                        if (k === 'id' || k === "tripId") return null;
                        if (k === 'owner') {
                          return (
                            <Table.Col key={`${i}-${k}`}>
                              <Avatar 
                                size="sm" 
                                imageURL={r['owner']['img']} 
                                onClick={() => setModalPhoto(r['owner']['img'])}
                                className="clickable" 
                              />
                              &nbsp;
                              {r['owner']['user']}
                            </Table.Col>
                          );
                        } else if (k === 'state') {
                          return (
                            <Table.Col key={`${i}-${k}`}>
                              <span className={`status-icon bg-${GetLabelColor(r[k])}`} />
                              {r[k]}
                            </Table.Col>
                          );
                        } else {
                          return (
                            <Table.Col key={`${i}-${k}`}>
                              {r[k]}
                            </Table.Col>
                          );
                        }
                      })}
                      <Table.Col>
                        <div className="actions-wrap">
                          <Button
                            outline
                            color="secondary"
                            size="sm"
                            onClick={() => openMainModal('shipment-view', r.id, null, r.tripId)}
                          >
                            View
                          </Button>

                          <Button
                            outline
                            color="danger"
                            className="ml-2 mr-2"
                            size="sm"
                            onClick={() => openMainModal('shipments--delete', r.id, reload)}
                          >
                            Delete
                          </Button>

                          <Button
                            outline
                            color="secondary"
                            className="ml-2"
                            size="sm"
                            onClick={() => openMainModal('shipment-assign', r.id)}
                          >
                            Assign
                          </Button>

                          {pathname.includes("PrimeShipment") && (
                            <Button
                              outline
                              color="secondary"
                              className="ml-2"
                              size="sm"
                              onClick={() => openMainModal('make-offer', r.id)}
                            >
                              Make Offer
                            </Button>
                          )}

                          <Button
                            outline
                            color="secondary"
                            className="ml-2"
                            size="sm"
                            onClick={() => setChatUser({ ID: r.owner.ID, username: r.owner.user, photo: r.owner.img })}
                          >
                            Chat
                          </Button>
                        </div>
                      </Table.Col>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </Dimmer>
      </Card>

      {chatUser && <Chat user={chatUser} onClose={() => setChatUser(null)} />}
    </Container>
  );
}

export default RecordsTable;